import { useContext } from "react";
import { DripsyThemeContext } from "./provider/context";
export var useDripsyTheme = function() {
    return useContext(DripsyThemeContext);
};
